<template>
    <div>
        <form @submit.prevent="store">
            <preloader v-if="loading"></preloader>
            <form-question :question="question" :errors="errors" ></form-question>
            <div class="columns">
                <div class="column">
                    <div class="block">
                        <div class="field is-grouped">
                            <p class="control">
                                <button class="button is-success" type="submit">Guardar</button>
                            </p>
                            <p class="control" >
                                <button class="button" type="reset" @click="cancel">Cancelar</button>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        name: "Create",
        data() {
            return {
                loading: false,
                errors: {},
                question: {},
                ready: false,
            }
        },
        props:{
            uuid: String,
        },
        mounted() {
            this.prepareComponent();
        },
        beforeRouteEnter (to, from, next) {
            next(vm => vm.prepareComponent())
        },
        methods: {
            prepareComponent() {
                this.loading = false;
                this.$root.preloader = false;
            },
            store() {
                this.$loader.show();
                this.errors = {};
                var questionData ={
                    "content":this.question.content,
                    "type":'say',
                    // "poll_id":this.question.poll.id,
                    "order":this.question.order,
                };

                this.$http.post('/ivr/question/', questionData).then(({data}) => {
                    console.log(data);
                    this.$notify.success(data.data);
                    this.$loader.hide();
                    this.$router.back();
                }, ({response}) => {
                    this.$loader.hide();
                    let data = response.data || {};
                    this.errors = data.errors || {};
                    this.$notify.danger(data.message);
                })
            },
            cancel() {
                this.$emit('cancel');
                this.$router.back();
            }
        }
    }
</script>

<style scoped>

</style>